module.exports = __webpack_public_path__ + "img/logo.d38055e4.png";